var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Facebook","d":"M87.271,21.455V11.681h3.337l.477-3.814H87.271V5.483c0-1.073.358-1.907,1.907-1.907H91.2V.119C90.727.119,89.535,0,88.224,0c-2.861,0-4.887,1.788-4.887,5.006V7.867H80v3.814h3.337v9.774Z","transform":"translate(-80)","fillRule":"evenodd"}));
}

Facebook.defaultProps = {"width":"11.204","height":"21.455","viewBox":"0 0 11.204 21.455"};

module.exports = Facebook;

Facebook.default = Facebook;
